<p-dialog
  header="Select Vehicles"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [baseZIndex]="1100"
  [style]="{ width: '30%', minHeight: '90%' }"
  (onHide)="cancel()"
>
  <!-- Filter input -->
  <div class="p-field search-field">
    <input
      type="text"
      pInputText
      placeholder="Search vehicles..."
      [(ngModel)]="filter"
    />
  </div>

  <!-- Warning when previously attached vehicles are unchecked -->
  @if (removedVehicles.length) {
    <div class="disconnect-warning">
      <i class="pi pi-exclamation-triangle"></i>
      <span>
        You are disconnecting the following
        {{ removedVehicles.length === 1 ? 'vehicle' : 'vehicles' }} from this restriction:
        <strong>{{ disconnectedVehicleNames }}</strong>
      </span>
    </div>
  }

  <!-- Vehicle list with checkboxes -->
    @for (vehicle of filteredVehicles; track vehicle) {
      <div class="vehicle">
        <p-checkbox
            [(ngModel)]="vehicle.selected"
            [binary]="true"
        ></p-checkbox>
        {{vehicle.name}}
      </div>
    }


  @if (noVehiclesSelected) {
    <div class="p-error">You need to select at least one vehicle for this restriction.</div>
  }

  <!-- Footer buttons -->
  <ng-template pTemplate="footer">
    <button pButton label="Cancel" class="p-button-secondary" (click)="cancel()"></button>
    <button pButton label="Add" icon="pi pi-check" (click)="confirmSelection()" [disabled]="noVehiclesSelected"></button>
  </ng-template>
</p-dialog>
